module.exports = __webpack_public_path__ + "img/dotted_bck.e8a7913d.png";